import script from "./ClipsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipsPanel.vue?vue&type=script&setup=true&lang=js"

import "./panel.css?vue&type=style&index=0&id=01cb16f6&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cb16f6"]])

export default __exports__